import esContent from './useBlockedWindowModal.es';

export default {
  ...esContent,
};
